export class CentralAtendimentoEventoRetorno {
  public eventoExecutado: boolean;
  public nomeArquivo: string;
  public urlArquivo: string;

  constructor() { }
}
